import { ref } from 'vue';
import type { RegionType } from '../../types/region';
import type { StoreRegion } from '../../store/region/region';

const regionData = ref<{ items: RegionType; language: string }>();

export const getRegion = async (regionDataUrl, storeId, caasLanguage) => {
  const storedRegionsData = sessionStorage.getItem(storeId);
  const parsedRegionsData: StoreRegion = storedRegionsData && JSON.parse(storedRegionsData);
  const storedLanguage = parsedRegionsData?.language?.toLowerCase();

  try {
    if (storedRegionsData) {
      if (caasLanguage === storedLanguage) {
        regionData.value = JSON.parse(storedRegionsData);
      } else {
        const response = await fetch(regionDataUrl);

        if (!response.ok) {
          throw new Error(`} >>> error, ${response.status}`);
        }

        const fetchedData = await response.json();

        if (fetchedData) {
          regionData.value = {
            items: fetchedData,
            language: caasLanguage,
          };
          sessionStorage.setItem(
            storeId,
            JSON.stringify({
              items: fetchedData,
              language: caasLanguage,
            }),
          );
        }

        console.debug(
          `${regionDataUrl} >>> Language unchanged: ${storeId}, data fetched due to lack of SessionStorage entry`,
          regionData.value,
        );
      }
    } else {
      const response = await fetch(regionDataUrl);

      if (!response.ok) {
        throw new Error(`} >>> error, ${response.status}`);
      }

      const fetchedData = await response.json();

      if (fetchedData) {
        regionData.value = {
          items: fetchedData,
          language: caasLanguage,
        };
        sessionStorage.setItem(
          storeId,
          JSON.stringify({
            items: fetchedData,
            language: caasLanguage,
          }),
        );
      }

      console.debug(`} >>> initialized`, regionData.value);
    }

    return regionData.value;
  } catch (error) {
    console.error(`${regionDataUrl} >>> error`, error);
  }
};
